// export const baseUrl = 'https://eae-c3pay-portal-web-a.azurewebsites.net/';
// export const baseUrl = "https://eae-c3pay-portal-web-d.azurewebsites.net/";

export const baseUrl = `${process.env.REACT_APP_API_URL}`;

// users  urls
export const getAuditTrailList = baseUrl + "/api/AuditTrail/search";
export const getManageUserList = baseUrl + "/api/PortalUsers/all-portalusers";
export const role = baseUrl + "/api/Lookup/role";

export const getReferrerCodeList =
  baseUrl + "/api/ReferrerCode/all-referrercodes";
export const getCreateReferrerCode = baseUrl + "/api/ReferrerCode";
export const getDeleteList = baseUrl + "/api/ReferrerCode/";
export const getDeleteUser = baseUrl + "/api/PortalUsers/";
export const getDeleteBlocklist = baseUrl + "/api/BlackList/";
export const reassignRoleurl = baseUrl + "/api/PortalUsers/";
export const getBlockList = baseUrl + "/api/BlackList/search";
export const searchBlocklist =
  baseUrl + "/api/BlackList/beneficiary-mapped-users";
export const saveBlocklist = baseUrl + "/api/BlackList/save";
export const getRegistrationList = baseUrl + "/api/User/registrations";
export const getUpdatedList = baseUrl + "/api/User/updates";
export const getRejectedList = baseUrl + "/api/User/rejections";
export const getVerificationList = baseUrl + "/api/User/verification/";

export const userListAndSearch = baseUrl + "/api/User/search";
export const userSearch = baseUrl + "/api/User/search/";
export const registrations = baseUrl + "/api/User/registrations/search";
export const registrationsearch = baseUrl + "/api/User/registrations/search";
export const updates = baseUrl + "/api/User/updates/search";
export const updatesearch = baseUrl + "/api/User/updates/search";
export const rejection = baseUrl + "/api/User/rejections/search";
export const rejectionsearch = baseUrl + "/api/User/rejections/search";
export const passwordRestUser = baseUrl + "/api/PortalUsers/reset/password/";
